import { timePickerDefaultProps } from '@hd-front-end/components/time-picker'
import { buildProps, definePropType } from '@hd-front-end/utils'

import type { ExtractPropTypes, __ExtractPublicPropTypes } from 'vue'
import type { DatePickerType } from '@hd-front-end/components/date-picker-panel/src/types'

export const datePickerProps = buildProps({
  ...timePickerDefaultProps,
  /**
   * @description type of the picker
   */
  type: {
    type: definePropType<DatePickerType>(String),
    default: 'date',
  },
} as const)

export type DatePickerProps = ExtractPropTypes<typeof datePickerProps>
export type DatePickerPropsPublic = __ExtractPublicPropTypes<
  typeof datePickerProps
>
